<template>
  <div class="wrapper-overlay">
    <div
      class="startup-screen"
      :style="{ background: wizard_tutoria ? '#f4f4f4' : '#1BA5A4' }"
    >
      <div class="screen-one" v-if="!wizard_tutoria">
        <h1>Hello {{ $getLoggedUser().manager_name | validate }}!</h1>
        <h4>Congratulations, You are now a Manager at</h4>
        <h4 class="company-name">{{ $getLoggedUser().company_name }}</h4>
        <img
          class="profile-logo"
          v-if="$getLoggedUser().company_logo"
          :src="$fullUrl('images/profiles/' + $getLoggedUser().company_logo)"
        />
        <img v-else class="profile-logo" src="@/assets/icons/logo_avatar.svg" />
        <p class="information">
          Enjoy Managing Consultants Profiles through the company CRM
        </p>
      </div>
      <template v-for="(item, index) in wizard_data">
        <div
          class="screen-next"
          :key="index"
          v-if="wizard_tutoria && item.active"
        >
          <div class="wizard-header">
            <img class="screen-image" :src="item.icon" />
            <span>{{ item.title }}</span>
          </div>
          <img class="screen-image" :src="item.img" />
          <p class="information" v-html="item.content"></p>
        </div>
      </template>
      <div class="wizard-option">
        <button @click="nextTo()" class="btn-get-started">
          <span v-if="!wizard_tutoria && wizard_data.length - 1 > current_index"
            >Get Started</span
          >
          <span v-if="wizard_tutoria && wizard_data.length - 1 > current_index"
            >Next</span
          >
          <span v-if="wizard_data.length - 2 < current_index">Finish</span>
        </button>
        <div class="bottom-option">
          <button
            @click="nextFrom()"
            v-if="wizard_tutoria && 0 < current_index"
            class="btn-back"
          >
            <span>Back</span>
          </button>
          <button
            class="btn-skip"
            @click="skipWizard()"
            :class="{ on_white: wizard_tutoria }"
          >
            Skip Tutorial
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "wrapper-overlay",
  components: {},
  data() {
    return {
      wizard_tutoria: false,

      wizard_data: [
        {
          title: "Search",
          icon: require("@/assets/admin-icon/search-active.svg"),
          img: require("@/assets/start-up-wizard/search-module.svg"),
          content:
            "This is a smart search that will provide results from items within the CRM",
          active: false,
          name: "search",
        },
        {
          title: "Heatmaps",
          icon: require("@/assets/admin-icon/home-active.svg"),
          img: require("@/assets/start-up-wizard/heatmap.svg"),
          content:
            "Heatmaps provide a list of all consultants showing their utilization and availability and enables status comments for each consultant.",
          active: false,
          name: "dashboard",
        },
        {
          title: "Tasks",
          icon: require("@/assets/admin-icon/task-active.svg"),
          img: require("@/assets/start-up-wizard/tasks.svg"),
          content:
            "Tasks help you organise your company’s activities, classify them and at the same time you can assign them to the responsible manager.",
          active: false,
          name: "task",
        },
        {
          title: "Leads",
          icon: require("@/assets/admin-icon/leads-active.svg"),
          img: require("@/assets/start-up-wizard/leads.svg"),
          content:
            "Leads will let you list all the possible opportunities from clients interested in your services. You can assign them to the responsible manager.",
          active: false,
          name: "leads",
        },
        {
          title: "Candidates",
          icon: require("@/assets/admin-icon/candidate-active.svg"),
          img: require("@/assets/start-up-wizard/candidates.svg"),
          content:
            "Through Candidates, you can get an overview and manage <br> the company recruitment process.",
          active: false,
          name: "candidates",
        },
        {
          title: "Accounts",
          icon: require("@/assets/admin-icon/customers-active.svg"),
          img: require("@/assets/start-up-wizard/accounts.svg"),
          content:
            "Accounts are your customers or potential customers. <br> You can access the projects you are or have worked on. You can also <br> find customer contacts  and other relevant customer information.",
          active: false,
          name: "accounts",
        },
        {
          title: "Organisation",
          icon: require("@/assets/admin-icon/organization-active.svg"),
          img: require("@/assets/start-up-wizard/organization.svg"),
          content:
            "This is where you manage all the information about your company such as company description, projects, consultants profiles, skills, etc.",
          active: false,
          name: "organization",
        },
        {
          title: "Assigmnments",
          icon: require("@/assets/admin-icon/assignment-active.svg"),
          img: require("@/assets/start-up-wizard/assingment.svg"),
          content:
            "Browse potential assignments, either internal or external, that matches <br> your services and assign them to consultants.",
          active: false,
          name: "assignment",
        },
        {
          title: "Resumes",
          icon: require("@/assets/admin-icon/resumes-active.svg"),
          img: require("@/assets/start-up-wizard/resumes.svg"),
          content:
            "Access all your consultants CVs in one place, apply CV templates to the consultant profiles and create professional pitches to your customers.",
          active: false,
          name: "resumes",
        },
        {
          title: "Reports",
          icon: require("@/assets/admin-icon/reports-active.svg"),
          img: require("@/assets/start-up-wizard/report.svg"),
          content:
            "Reports will let you track progress and growth, identify trends or any irregularities that may need further investigation regarding the tasks, leads, candidates and skills",
          active: false,
          name: "reports",
        },
      ],
      current_index: -1,
    };
  },
  watch: {},
  methods: {
    skipWizard() {
      let vm = this;
      vm.$emit("checkWizard", false);
      vm.$localStorage.set(
        vm.$getLoggedUser().email + "_crm_start_up_wizard",
        true
      );
      vm.$store.commit("SET_WIZARD_ACTIVE_MENU", "");
    },
    nextTo() {
      let vm = this;
      vm.current_index += 1;
      if (vm.wizard_data.length > vm.current_index) {
        vm.wizard_tutoria = true;
        vm.wizard_data.forEach((item) => {
          item.active = false;
        });
        vm.wizard_data[vm.current_index].active = true;
        vm.$store.commit(
          "SET_WIZARD_ACTIVE_MENU",
          vm.wizard_data[vm.current_index].name
        );
      } else {
        vm.$emit("checkWizard", false);
        vm.$localStorage.set(
          vm.$getLoggedUser().email + "_crm_start_up_wizard",
          true
        );
        vm.$store.commit("SET_WIZARD_ACTIVE_MENU", "");
      }
    },
    nextFrom() {
      let vm = this;
      vm.current_index -= 1;
      if (0 <= vm.current_index) {
        vm.wizard_tutoria = true;
        vm.wizard_data.forEach((item) => {
          item.active = false;
        });
        vm.wizard_data[vm.current_index].active = true;
        vm.$store.commit(
          "SET_WIZARD_ACTIVE_MENU",
          vm.wizard_data[vm.current_index].name
        );
      }
    },
  },
  computed: {},
  created() {
    let vm = this;
    if (
      vm.$localStorage.get(vm.$getLoggedUser().email + "_crm_start_up_wizard")
    ) {
      vm.$emit("checkWizard", false);
    } else {
      vm.$emit("checkWizard", true);
    }
  },
};
</script>
<style lang="scss" scoped>
.wrapper-overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 99999999999999;
  background: rgba($color: #000000, $alpha: 0.8);
  display: block;
  padding-top: 70px;
  padding-left: 50px;
  .startup-screen {
    width: 700px;
    margin: 0 auto;
    min-height: 400px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 30px 30px;
    .screen-one {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      h1 {
        font-weight: 800;
        font-size: 32px;
        margin: 0px;
        color: #fff;
      }
      h4 {
        font-weight: 800;
        font-size: 20px;
        font-size: 16px;
        color: #fff;
        margin: 5px 0px;
      }
      h4.company-name {
        font-weight: 800;
        font-family: "AvenirBlack";
      }
      .profile-logo {
        height: 60px;
        width: 60px;
        border-radius: 50%;
        background: #fff;
      }
      .information {
        color: #e7e7e7;
        padding: 10px 0px;
      }
    }
  }
  .screen-next {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .wizard-header {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;
      img {
        width: 38px;
        margin: 0px;
        margin-right: 9px;
      }
      span {
        color: #1ba5a4;
        font-size: 35px;
        font-weight: 800;
        position: relative;
        top: 5px;
      }
    }
    .screen-image {
      width: 90%;
      margin-bottom: 30px;
    }
    .information {
      margin-top: 0px;
      margin-bottom: 30px;
      font-size: 16px;
      color: #676767;
      text-align: center;
    }
  }
  .wizard-option {
    display: flex;
    flex-direction: column;
    .btn-get-started {
      border-radius: 5px;
      color: #1ba5a4;
      background: #fff;
      height: 43px;
      width: 182px;
      margin-bottom: 11px;
    }
    .bottom-option {
      display: flex;
      justify-content: center;
      .btn-back {
        margin-right: 20px;
        color: #0884af;
      }
      .btn-skip {
        color: #fff;
        &.on_white {
          color: #000;
        }
      }
    }
  }
}
</style>
